<template>
  <v-dialog
    v-model="dialog_params_over.show"
    scrollable
    max-width="1200px"
    :width="dialog_params_over.size"
  >
    <v-card style="background-color: #eee">
      <v-card-title
        style="background-color: #ffffff; border-bottom: 1px solid #ccc"
      >
        <span class="text-h5">{{ dialog_params_over.title }}</span>

        <v-spacer></v-spacer>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <slot name="body">
            {{ dialog_params_over.text }}
          </slot>
        </v-container>
      </v-card-text>

      <v-card-actions
        style="background-color: #ffffff; border-top: 1px solid #ccc"
        v-show="dialog_params_over.buttons"
      >
        <v-spacer></v-spacer>
        <slot name="buttons">
          <v-btn class="primary">Save</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalOver",
  props: {
    dialog_over: { type: Boolean, default: false },
    dialog_params_over: {
      type: Object,
      default: { title: "ModalOver", size: "80%", show: false },
    },
  },
  methods: {
    close: function () {
      this.$root.$emit("Modal-Hide-Over");
    },
  },
};
</script>
